export default "__VITE_ASSET__D3E_9cmB__"